import type { CheckoutSession } from "./types";

function readString(value: unknown): string | undefined {
  return typeof value === "string" && value.length > 0 ? value : undefined;
}

export function normalizeCheckoutSession(data: unknown): CheckoutSession {
  if (!data || typeof data !== "object") {
    throw new Error("Invalid checkout response");
  }
  const raw = data as Record<string, unknown>;

  if (typeof raw.error === "string") {
    throw new Error(raw.error);
  }

  const provider = raw.provider === "stripe" ? "stripe" : "polar";

  if (provider === "stripe") {
    const id = readString(raw.id);
    const client_secret = readString(raw.client_secret);
    if (!id || !client_secret) {
      throw new Error("Stripe checkout response missing id or client_secret");
    }
    return { provider: "stripe", id, client_secret };
  }

  const url = readString(raw.url);
  const id = readString(raw.id) ?? readString(raw.checkout_id);
  if (!url) {
    throw new Error("Polar checkout response missing url");
  }
  if (!id) {
    throw new Error("Polar checkout response missing id");
  }
  return { provider: "polar", url, id };
}
